import FullScreenDialog, { FullScreenDialogCloseReason } from "../../../../components/full-screen-dialog/FullScreenDialog";
import { BindDialogReturn, DialogProps, DialogResult, DialogState } from "../../../../hooks/use-dialog-state/UseDialogState";
import UserEditor from "./UserEditor";

import type { JSX } from "react";

export type UserEditorDialogInitValues = {
    userID: number;
    organizationID: number | undefined;
    allowSSO?: boolean; // Optional, used to determine if SSO is allowed for the user
};

export type UserEditorDialogResultValues = {
    userID: number | undefined;
};

export type UserEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "saveAsNew" | "saveChanges";

export type UserEditorDialogResult = DialogResult<UserEditorDialogResultValues, UserEditorDialogResultReason>;

export type UserEditorDialogProps = DialogProps<UserEditorDialogInitValues, UserEditorDialogResult>;

export default function UserEditorDialog({
    open,
    onClose,
    values
}: UserEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <UserEditor
                userID={values?.userID}
                organizationID={values?.organizationID}
                allowSSO={values?.allowSSO}
                onClose={({reason, userID}) => onClose({
                    reason: reason,
                    values: {
                        userID: userID
                    }
                })}
            />
        </FullScreenDialog>
    );
}

export type UserEditorDialogState = DialogState<UserEditorDialogInitValues, UserEditorDialogResult>;
export type BindUserEditorDialogReturn = BindDialogReturn<UserEditorDialogInitValues, UserEditorDialogResult>;